import type { InvoiceData } from '../types';

type PillTone = 'ok' | 'bad' | 'off';

export const INVOICE_STATUS: Record<InvoiceData['status'], { tone: PillTone; label: string }> = {
  PAID: { tone: 'ok', label: 'Paid' },
  UNPAID: { tone: 'bad', label: 'Unpaid' },
  REFUNDED: { tone: 'off', label: 'Refunded' },
};

export const canPayInvoice = (invoice: InvoiceData): boolean => invoice.status === 'UNPAID';
